import cn from 'classnames'
import GatsbyLink from 'gatsby-link'
import * as pathToRegexp from 'path-to-regexp'
import React from 'react'
import { LinkProps as BaseLinkProps } from '@joehua/react-link'
import { RouteProps } from '@joehua/cms-components'
import { AppConfig } from '@joehua/cms-components'

export interface LinkProps extends BaseLinkProps {
  title?: string
  activeClassName?: string
  onClick?: (e: any) => void
}

export function routeToString(
  route: RouteProps,
  routesMap: { [key: string]: any },
) {
  const { name, params } = route
  const pattern = routesMap[name]
  const toPath = pathToRegexp.compile(pattern)
  const path = toPath(params || {})
  return path
}

export default ({
  title,
  to,
  children,
  className,
  activeClassName,
  onClick,
}: LinkProps) => {
  return (
    <AppConfig>
      {({ routesMap }) => {
        if (!to) {
          return children
        }
        if (typeof to === 'string') {
          return (
            <GatsbyLink
              activeClassName={activeClassName}
              className={cn('link', className)}
              title={title}
              to={to}
              onClick={onClick}
            >
              {children}
            </GatsbyLink>
          )
        }
        const path = routeToString(to, routesMap)
        return (
          <GatsbyLink
            activeClassName={activeClassName}
            className={cn('link', className)}
            title={title}
            to={path}
            onClick={onClick}
          >
            {children}
          </GatsbyLink>
        )
      }}
    </AppConfig>
  )
}
